import * as yup from "yup";
import { useState } from "react";
import { Trans } from "react-i18next";
import { toast } from "react-toastify";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Loaing from "../../icons/loaing";
import ConfirmModal from "../ConfirmModal";
import Input from "../event-selection/Input";
import TextArea from "../event-selection/textArea";
import Checkboxes from "../event-selection/checkboxes";
import SelectAndQmark from "../event-selection/select&Qmark";
import SelectElement from "../event-selection/selectElement";
import { closeReporting } from "../../services/dashboardService";
import { updateIncidentService } from "../../services/incidentsService";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { IncidentsPDF } from "./incidents-pdf";
import CustomCheckboxes from "../event-selection/customCheckboxes";
import moment from "moment";
import DeletePopup from "./delete-popup";
import { UPDATE_VALUES } from "../../data/constants";
import FormDateInput from "../FormDateInput";
import AdminWrapper from "../misc/AdminWrapper";

export type updateIncidentsInputeTypes = {
  selectedPeriod: string;
  __v: number;
  _id: string;
  reporting: string;
  reportingId: string;
  eventDate: string;
  eventTime: Date;
  eventMoment: string;
  eventLocation: string;
  precisionTypeEvent: string;
  eventDescription: string;
  consequences: string;
  emsContacted: string;
  hospitalization: string;
  insuranceBeNotified: string;
  insuranceBeenNotified: string;
  localAuthorityBeNotified: string;
  localAuthorityBeenNotified: string;
  parentsBeenInformed: string;
  securityLevel: string;
  aftercare: string;
  childAbsence: string;
  supervisionRateRespected: string;
  usualTeam: string;
  professionalNames: string;
  immediateCorrectiveActionsArray?: string[];
  immediateCorrectiveActions: string;
  riskRelatedEventArray?: string[];
  riskRelatedEvent: string;
  eventAvoidedSafer: string;
  recurrence: string;
  ageOfChild: string;
  printeventDate: boolean;
  printeventTime: boolean;
  printeventMoment: boolean;
  printeventLocation: boolean;
  printprecisionTypeEvent: boolean;
  printeventDescription: boolean;
  printconsequences: boolean;
  printemsContacted: boolean;
  printhospitalization: boolean;
  printinsuranceBeNotified: boolean;
  printinsuranceBeenNotified: boolean;
  printlocalAuthorityBeNotified: boolean;
  printlocalAuthorityBeenNotified: boolean;
  printparentsBeenInformed: boolean;
  printsecurityLevel: boolean;
  printaftercare: boolean;
  printchildAbsence: boolean;
  printsupervisionRateRespected: boolean;
  printusualTeam: boolean;
  printprofessionalNames: boolean;
  printimmediateCorrectiveActionsArray: boolean;
  printimmediateCorrectiveActions: boolean;
  printriskRelatedEventArray: boolean;
  printriskRelatedEvent: boolean;
  printeventAvoidedSafer: boolean;
  printrecurrence: boolean;
  printageOfChild: boolean;
  setOpen: (value: boolean) => void;
  updateRecord: (value: any) => void;
};

const schema = yup.object({
  eventDate: yup.string().required(),
  eventTime: yup.string().required(),
  eventMoment: yup.string().required(),
  eventLocation: yup.string().required(),
  precisionTypeEvent: yup.string().required(),
  eventDescription: yup.string().required(),
  consequences: yup.string().required(),
  emsContacted: yup.string().required(),
  hospitalization: yup.string().required(),
  insuranceBeNotified: yup.string().required(),
  insuranceBeenNotified: yup.string().required(),
  localAuthorityBeNotified: yup.string().required(),
  localAuthorityBeenNotified: yup.string().required(),
  parentsBeenInformed: yup.string().required(),
  securityLevel: yup.string().required(),
  aftercare: yup.string().required(),
  childAbsence: yup.string().required(),
  supervisionRateRespected: yup.string().required(),
  usualTeam: yup.string().required(),
  professionalNames: yup.string().required(),
  immediateCorrectiveActionsArray: yup
    .array()
    .min(1, "immediateCorrectiveActions is a required field!")
    .test(
      "no-empty-strings",
      "Array cannot contain empty string values",
      (value) => {
        return new Promise((resolve) => {
          resolve(value?.every((item) => item !== "") ?? false);
        });
      }
    ),
  riskRelatedEventArray: yup
    .array()
    .min(1, "riskRelatedEvent is a required field!")
    .test(
      "no-empty-strings",
      "Array cannot contain empty string values",
      (value) => {
        return new Promise((resolve) => {
          resolve(value?.every((item) => item !== "") ?? false);
        });
      }
    ),
  eventAvoidedSafer: yup.string().required(),
  recurrence: yup.string().required(),
  ageOfChild: yup.string().required(),
});
const UpdateIncidents: React.FC<updateIncidentsInputeTypes> = ({
  reportingId,
  setOpen,
  updateRecord,
  selectedPeriod,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [editEnabled, setEditEnabled] = useState(false);
  const [pdfData, setPdfData] = useState<any>(null);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [date, setDate] = useState<string>(
    props.eventDate === "Invalid date"
      ? moment(selectedPeriod).format("YYYY-MM-DD")
      : props.eventDate
  );

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<updateIncidentsInputeTypes>({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props,
    },
    mode: "onSubmit",
    shouldUnregister: false,
  });

  const handleDownload: SubmitHandler<updateIncidentsInputeTypes> = async (
    data
  ) => {
    data.riskRelatedEvent =
      data.riskRelatedEventArray?.map((value) => value).join("-,-") ?? "";
    data.printriskRelatedEvent = data.printriskRelatedEventArray;
    data.immediateCorrectiveActions =
      data.immediateCorrectiveActionsArray?.map((value) => value).join("-,-") ??
      "";
    data.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
    data.printimmediateCorrectiveActions =
      data.printimmediateCorrectiveActionsArray;
    setPdfData(data);
  };
  const resetForm = () => {
    setConfirmModalVisible(false);
    reset();
  };

  const updateReporting = async (value: string) => {
    setLoading(true);
    try {
      const response = await closeReporting(reportingId, { status: value });
      if (response.message === "updated") {
        updateRecord(response.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const onSubmit: SubmitHandler<updateIncidentsInputeTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printaftercare,
        printageOfChild,
        printchildAbsence,
        printconsequences,
        printemsContacted,
        printeventAvoidedSafer,
        printeventDate,
        printeventDescription,
        printeventLocation,
        printeventMoment,
        printeventTime,
        printhospitalization,
        printimmediateCorrectiveActionsArray,
        printimmediateCorrectiveActions,
        printinsuranceBeNotified,
        printinsuranceBeenNotified,
        printlocalAuthorityBeNotified,
        printlocalAuthorityBeenNotified,
        printparentsBeenInformed,
        printprecisionTypeEvent,
        printprofessionalNames,
        printrecurrence,
        printriskRelatedEvent,
        printsecurityLevel,
        printsupervisionRateRespected,
        printusualTeam,
        printriskRelatedEventArray,
        ...rest
      } = data;
      
      // Vérifier si le niveau de sécurité a changé
      const oldSecurityLevel = props.securityLevel;
      const newSecurityLevel = data.securityLevel;
      
      // Log pour debug
      console.log("Old security level:", oldSecurityLevel);
      console.log("New security level:", newSecurityLevel);
      
      rest.immediateCorrectiveActions =
        rest.immediateCorrectiveActionsArray
          ?.map((value) => value)
          .join("-,-") ?? "";
      rest.riskRelatedEvent =
        rest.riskRelatedEventArray?.map((value) => value).join("-,-") ?? "";
      rest.eventDate = moment(data.eventDate).format("YYYY-MM-DD");
      delete rest.immediateCorrectiveActionsArray;
      delete rest.riskRelatedEventArray;
      
      const response = await updateIncidentService(rest, data._id);
      
      if (response.message === "updated") {
        // Si le niveau de sécurité passe de <3 à ≥3, mettre à jour le statut dans le frontend également
        if (
          (oldSecurityLevel === "0" || oldSecurityLevel === "1" || oldSecurityLevel === "2") && 
          (newSecurityLevel === "3" || newSecurityLevel === "4" || newSecurityLevel === "5")
        ) {
          console.log("Updating status to Need Validation in frontend");
          // S'assurer que le statut est correctement mis à jour dans l'interface
          response.data.status = "Need Validation";
        }
        // Si le niveau de sécurité passe de ≥3 à <3, mettre à jour le statut à "Closed" dans le frontend
        else if (
          (oldSecurityLevel === "3" || oldSecurityLevel === "4" || oldSecurityLevel === "5") && 
          (newSecurityLevel === "0" || newSecurityLevel === "1" || newSecurityLevel === "2")
        ) {
          console.log("Updating status to Closed in frontend");
          // S'assurer que le statut est correctement mis à jour dans l'interface
          response.data.status = "Closed";
        }
        
        updateRecord(response?.data);
        toast.success("Your action has been successfully saved!");
        setLoading(false);
        setOpen(false);
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };

  const deleteEvent = (deleteConfirmed: boolean) => {
    if (deleteConfirmed) {
      setOpenDeletePopup(false);
      updateReporting(UPDATE_VALUES.DELETED);
    } else {
      setOpenDeletePopup(false);
    }
  };
  return (
    <section className="relative font-Poppins">
      <AdminWrapper>
        <DeletePopup
          deleteEvent={deleteEvent}
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
        />
      </AdminWrapper>
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans>Incidents</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans>incidents_description</Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end gap-[15px] lg:mx-[20px] my-10">
          <AdminWrapper>
            {editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setConfirmModalVisible(true)}
              >
                <Trans>Reset</Trans>
              </button>
            )}
            {!editEnabled && (
              <button
                type="button"
                className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
                onClick={() => setEditEnabled(true)}
              >
                <Trans>Edit</Trans>
              </button>
            )}
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => setOpenDeletePopup(true)}
            >
              <Trans>Delete</Trans>
            </button>
            <button
              type="button"
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={() => updateReporting(UPDATE_VALUES.CLOSED)}
            >
              <Trans>Validate</Trans>
            </button>
          </AdminWrapper>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<IncidentsPDF formData={pdfData ?? {}} />}
              fileName={"incident.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>
        <div className="relative z-0 border border-gray-500 lg:mx-5">
          <div className="absolute -top-3 left-5 lg:-top-5 lg:left-14 bg-[white] px-[20px] lg:px-5">
            <h1 className="text-sm lg:text-3xl font-bold text-[#1E408E]">
              <Trans i18nKey="Event Details">Event Details</Trans>
            </h1>
          </div>
          <div className="md:p-16 sm:p-8 p-4 pt-8 md:pt-16">
            <div className="grid gap-5">
              <FormDateInput
                type="Date"
                register={register}
                errors={errors}
                name="eventDate"
                printEnabled
                label="Event date"
                placeholder=""
                translateId="Event date"
                disabled={!editEnabled}
                date={date}
                setDate={setDate}
                control={control}
              />
              <Input
                type="Time"
                register={register}
                errors={errors}
                printEnabled
                name="eventTime"
                label="Event time"
                placeholder="hh:mm"
                translateId="Event date"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                printEnabled
                errors={errors}
                name="eventMoment"
                label="Event moment"
                options={[
                  "Play time",
                  "Sleep time",
                  "Changing/care time",
                  "Meal time",
                  "Reception time (morning and evening)",
                ]}
                translateId="Event moment"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                printEnabled
                errors={errors}
                name="eventLocation"
                label="Event location"
                options={[
                  "Interior (School indoor premise)",
                  "Exterior space (School outdoor premise)",
                  "Outside the establishment",
                ]}
                translateId="Event location"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="ageOfChild"
                label="Age of the child involved in the incident"
                options={[
                  "Less than 1 year",
                  "1 to 2 years",
                  "2 to 3 years",
                  "3 to 4 years",
                  "4 to 5 years",
                  "5 to 6 years",
                  "More than 6 years old",
                ]}
                translateId="Aga of the child"
                disabled={!editEnabled}
              />
              <Checkboxes
                register={register}
                printEnabled
                errors={errors}
                name="precisionTypeEvent"
                options={[
                  { text: "High fall" },
                  { text: "Fall from a small height" },
                  { text: "Fall of object.furniture on the child" },
                  { text: "Shock between people / bites" },
                  { text: "Shock against a wall / furniture / object" },
                  { text: "Fingers / feet caught" },
                  { text: "Ingestion of foreign body / toxic product" },
                  { text: "Insect bite" },
                  { text: "Inapproriate touch" },
                ]}
                label="Precision on the type of event"
                translateId="Precision on the type of event"
                disabled={!editEnabled}
              />
              <TextArea
                printEnabled
                register={register}
                errors={errors}
                name="eventDescription"
                label="Event Description (factual & taken care of elements)"
                translateId="eventDescription"
                disabled={!editEnabled}
              />
              <Checkboxes
                register={register}
                errors={errors}
                printEnabled
                name="consequences"
                options={[
                  { text: "Slight abrasion" },
                  { text: "Deep scratch" },
                  { text: "Superficial cut" },
                  { text: "Deep cut" },
                  { text: "Bumps/blues" },
                  { text: "Head trauma" },
                  { text: "Surface bite with broken skin" },
                  { text: "Deep bite with open wound" },
                  { text: "Damaged teeth/gums" },
                  { text: "Limb section, amputation" },
                  { text: "Fracture" },
                  { text: "Choking" },
                  { text: "Swelling" },
                  { text: "Others" },
                ]}
                label="Consequences"
                translateId="Consequences"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                printEnabled
                errors={errors}
                name="emsContacted"
                label="EMS contacted"
                options={["Yes", "No"]}
                translateId="EMS contacted"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="hospitalization"
                options={[
                  "No",
                  "Less than 24H",
                  "Less than 36H",
                  "Less than 48H",
                  "More than 48H",
                ]}
                label="Hospitalization (including emergency room)"
                translateId="hospitalization"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="childAbsence"
                printEnabled
                label="Child absence"
                options={[
                  // "No absence",
                  // "Returned the next day",
                  // "Absence of 1 to 3 days",
                  // "Absence for more than 3 days",
                  // "Parents have terminated the service",
                  "No absence or maximum 1 day",
                  "Maximum 2 days",
                  "Maximum 3 days",
                  "Maximum 1 week",
                  "More than one week",
                  "Parents terminated the care agreement",
                ]}
                translateId="Child absence"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="aftercare"
                label="Aftercare"
                options={[
                  "No",
                  "Yes, for few days",
                  "Yes, for few weeks",
                  "Yes, for few months",
                  "Yes, for more than a year",
                ]}
                translateId="Aftercare"
                disabled={!editEnabled}
              />
              <SelectAndQmark
                register={register}
                errors={errors}
                name="securityLevel"
                label="Severity level"
                options={[0, 1, 2, 3, 4, 5]}
                translateId="Severity level"
                printEnabled
                disabled={!editEnabled}
                i18nKey="Help Box - Incidents - Severity level"
                value={props.securityLevel}
              />

              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="parentsBeenInformed"
                label="Have the parents been informed according to the instructions?"
                options={["Yes", "No"]}
                translateId="parentsBeenInformed"
                disabled={!editEnabled}
              />
              <SelectAndQmark
                register={register}
                errors={errors}
                name="insuranceBeNotified"
                label="Should the Insurance be notified?"
                options={["Yes", "No"]}
                translateId="insuranceBeNotified"
                disabled={!editEnabled}
                i18nKey="Help Box - Incidents - Does our Company Insurance need to be informed ?"
                printEnabled
                value={props.insuranceBeNotified}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="insuranceBeenNotified"
                label="Has the Insurance been notified?"
                options={["Yes", "No"]}
                translateId="insuranceBeenNotified"
                disabled={!editEnabled}
                printEnabled
              />
              <SelectAndQmark
                register={register}
                errors={errors}
                name="localAuthorityBeNotified"
                label="Should the local authority be notified?"
                options={["Yes", "No"]}
                translateId="localAuthorityBeNotified"
                disabled={!editEnabled}
                i18nKey="Help Box - Incidents - Does the local authority need to be informed?"
                printEnabled
                value={props.localAuthorityBeNotified}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="localAuthorityBeenNotified"
                label="Has the local authority been notified?"
                options={["Yes", "No"]}
                translateId="localAuthorityBeenNotified"
                disabled={!editEnabled}
                printEnabled
              />

              <SelectAndQmark
                register={register}
                errors={errors}
                name="supervisionRateRespected"
                label="supervisionRateRespected"
                options={["Yes", "No"]}
                translateId="supervisionRateRespected"
                disabled={!editEnabled}
                printEnabled
                i18nKey="Help Box - Incidents - When the event occurred, was the staff ratio in compliance with regulations?"
              />
              <SelectElement
                register={register}
                errors={errors}
                name="usualTeam"
                label="Usual team in the reception area?"
                options={["Yes", "No"]}
                translateId="usualTeam"
                printEnabled
                disabled={!editEnabled}
              />
              <TextArea
                register={register}
                errors={errors}
                name="professionalNames"
                label="Name of all professionals present in the unit where the event took place"
                translateId="professionalNames"
                disabled={!editEnabled}
                printEnabled
              />
              <CustomCheckboxes
                control={control}
                register={register}
                errors={errors}
                printEnabled
                disabled={!editEnabled}
                name="immediateCorrectiveActionsArray"
                options={[
                  { text: "Rearrangement of the space" },
                  {
                    text: "Awarness for the team, reminder of the protocol(s)",
                  },
                  { text: "Review of the field organization" },
                  {
                    text: "Review of the schedules",
                  },
                  {
                    text: "Removal of the object/furniture that caused the accident or the risk of accident",
                  },
                  {
                    text: "Locking down of the risk area / securing pending maintenance/work intervention",
                  },
                  {
                    text: "Emergency intervention for corrective repair/maintenance (e.g.: window, anti-twist, sharp edges...)",
                  },
                  {
                    text: "none",
                  },
                ]}
                label="Immediate corrective actions"
              />
              <CustomCheckboxes
                control={control}
                disabled={!editEnabled}
                register={register}
                printEnabled
                errors={errors}
                name="riskRelatedEventArray"
                label="Risks related to the Health incident"
                options={[
                  {
                    text: "Risk of parents negatively influencing other parents in the school",
                  },
                  {
                    text: "Risk that parents will give bad publicity (social networks, negative comments on the internet)",
                  },
                  { text: "Legal risk (lawsuit)" },
                  { text: "Risk of partial closure of the school" },
                  { text: "Risk of temporary closure of the school" },
                  { text: "none" },
                ]}
              />
              <SelectElement
                register={register}
                errors={errors}
                name="eventAvoidedSafer"
                printEnabled
                label="Could the event have been avoided with safer equipment?"
                options={["Yes", "No", "Not applicable"]}
                translateId="eventAvoidedSafer"
                disabled={!editEnabled}
              />
              <SelectElement
                register={register}
                errors={errors}
                printEnabled
                name="recurrence"
                label="Recurrence"
                options={[
                  "No, isolated incident",
                  "Yes, same type of incident happened in the last 3 months",
                ]}
                translateId="Recurrence"
                disabled={!editEnabled}
              />
            </div>
          </div>
        </div>
        <AdminWrapper>
          <div className="flex justify-end lg:px-[20px] my-10">
            <button
              type={"submit"}
              className="px-5 py-2 rounded-full cursor-pointer text-white bg-[#1E408E]"
            >
              <Trans>Submit</Trans>
            </button>
            {loading && <Loaing />}
          </div>
        </AdminWrapper>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default UpdateIncidents;
